import { useClientConfigProvider } from "@/app/config/client-config-provider";
import LoginV1 from "./v1/v1";
import LoginV2 from "./v2/v2";

function LoginPage() {
  const { config } = useClientConfigProvider();
  if (config?.designVersion === "v1") {
    return <LoginV1 />;
  }
  if (config?.designVersion === "v2") {
    return <LoginV2 />;
  }
}

// export const maskEmail = (email?: string) => {
//   if (!email) return "";

//   const [localPart, domain] = email.split("@");
//   if (!domain) return email; // invalid email format, return as is

//   const visibleChars = 4;
//   const maskedLocal =
//     localPart.slice(0, visibleChars) +
//     "*".repeat(Math.max(localPart.length - visibleChars, 0));

//   return `${maskedLocal}@${domain}`;
// };

export const maskEmail = (email?: string) => {
  if (!email) return "";

  const [localPart, domain] = email.split("@");
  if (!domain) return email; // invalid email format

  const visibleChars = 2;
  const maskedLocal =
    localPart.slice(0, visibleChars) +
    "*".repeat(Math.max(localPart.length - visibleChars, 0));

  const [domainName, tld] = domain.split(".");
  const domainVisible = 1;
  const maskedDomain =
    domainName.slice(0, domainVisible) +
    "*".repeat(Math.max(domainName.length - domainVisible, 0));

  return `${maskedLocal}@${maskedDomain}.${tld || ""}`;
};
export default LoginPage;
